import React, { Fragment, useEffect, useState } from "react";
import make from "../../assets/utils/images/Intagration image/make.png";
import requestApiService from "../../services/requestApi.service";
import { confirmBox, loadConnectedIntegration } from "../../Common/Appcommon";
import { cardData } from "./Constants";
import ShowIntegrationInfo from "./ShowIntDetails.js";

const Make = (props) => {
    let { install, installedButton, buttonValue, name } = props;
    const [isConnected, setConnectionStatus] = useState(false);
    const [carddata, setData] = useState(cardData);
    const [accountInfo, setAccountInfo] = useState([]);
    let key = '';
    let foundData = carddata.find((data) => data.name === "make");
    if (foundData) {
        key = foundData.component.button.key;
    }
    let integrationData = [];
    const [tabInfo, setTabInfo] = useState([]);
    useEffect(() => {
        (async () => {
            if(install === true){
                onInstallMake();
            }
            await fetchGoogleAccountDetails();
        })();
        return () => {
            // this now gets called when the component unmounts
        };
    }, [install]);

    const fetchGoogleAccountDetails = async () => {
        let integrationInfo = await loadConnectedIntegration(name); //'gcalendar'
        if (integrationInfo.length > 0) {
            setConnectionStatus(true);
            let connectedInfo = integrationInfo[0][2];
            connectedInfo = JSON.parse(connectedInfo);
            let token = connectedInfo['token']['access_token'];
            let reftoken = connectedInfo['token']['refresh_token'];
            let IntegrationAccountInfo = [
                { type: "id", id: integrationInfo[0][0] },
                { type: "text", label: "Token", value: token },
                { type: "text", label: "Refresh Token", value: reftoken },
            ];
            setAccountInfo(IntegrationAccountInfo);
        } else {
            integrationData = [];
            setConnectionStatus(false);
            setTabInfo([]);
        }

    };


    const onInstallMake = async (e) => {
        window.open("https://www.make.com/en/integrations/gateway", '_blank');
        /* let appHost = window.location.hostname;
        let protocol = window.location.protocol;
        let callback = protocol + "//" + appHost + "/#/oauth/callback";
        // https://www.make.com/en/integrations/gateway
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "GET_OAUTH_URL",
            NAME: "MAKE",
            CALLBACK: callback
        }
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            let authUrl = response.data;
            window.parent.location.href = authUrl;
        } */
    }

    const removeIntegration = async (e, integrationId) => {
        let confirm = await confirmBox("Are you sure want to Uninstall " + integrationHeadData.name + "?", "Uninstalling the " + integrationHeadData.name + " app all actions linked to it will stop working.", 'warning', 'Uninstall', 'Cancel');
        if (!confirm) {
            return;
        }
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "REMOVE_INTEGRATION",
            ID: integrationId
        }
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            // installedButton();
            // setintegrationId('');
            await fetchGoogleAccountDetails();
        }
    }

    /* const getSimpleTabs = () => {
        return tabInfo.map(({ name, biography }, index) => ({
            key: index,
            title: name,
            getContent: () => biography, // Render function if it's a component
        }));
    } */


    const integrationHeadData = {
        name: "Make",
        tag: "Automation",
        image: make,
        installButtonText: "Install App",
        uninstallButtonText: "Uninstall App",
    };

    const integrationContent = [
        { heading: "Website", subheading: "https://www.make.com/", type: "url" },
        { heading: "Overview", subheading: "Connect your AI Voice Agent with Make.com to automate lead workflows and trigger powerful multi-app actions after every call. Whether syncing with external tools like Calendly, CRMs, or marketing platforms, Make.com extends your voice AI automation without writing a single line of code.", type: "text" },
        { heading: "Key Benefits", 
            subheading: [
                { 
                    title: "Automate lead actions",
                    description: "Create, Update, Tag, or Move leads between lists with webhooks." 
                },
                { 
                    title: "Trigger custom workflows", 
                    description: "Connect with CRMs, Google Sheets, or other tools to execute post-call actions." 
                },
                { 
                    title: "Manage scheduling with Calendly", 
                    description: "Automate booking, rescheduling, or canceling appointments in real time." 
                },
                { 
                    title: "Connect with 1000+ apps", 
                    description: "Use Make.com’s powerful integrations to expand what your voice AI platform can do." 
                },], type: "list" },
        { heading: "How It Works", 
            subheading: [
                { 
                    title: "Create/Update Leads (via Webhooks)",
                    description: "Automatically create or update lead records, manage tags, assign to lists, and update custom fields—triggered in real time through webhook flows." 
                },
                { 
                    title: "Sync Data Across Tools (via Custom Actions)", 
                    description: "Pull data from CRMs, Google Sheets, or other platforms to personalize conversations. Post-call, push updates back—ensuring all systems stay in sync." 
                },
                { 
                    title: "Calendar Automation (via Custom Actions)", 
                    description: "Check availability and manage appointments using tools like Calendly. Book, cancel, or reschedule directly from calls using Make.com-powered workflows." 
                },
        ], type: "list" }
        
    ];


    return (
        <Fragment>
            <div className="agent-details">
                <ShowIntegrationInfo
                    keyname={name}
                    headData={integrationHeadData}
                    integrationData={integrationContent}
                    isInstalled={buttonValue.includes(name)}
                    isConnected={isConnected}
                    accountInfo={accountInfo}
                    onInstall={onInstallMake}
                    onRemove={removeIntegration}
                />
            </div>
        </Fragment>
    );


}

export default Make;
